module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("ECHALLAN 01 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportChallanDataToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export to Excel\n        ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vehicle No(CG07BC9186)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllVehicleDDList'],
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Select Vehicle No"
    },
    model: {
      value: (_vm.vehiclenumber),
      callback: function($$v) {
        _vm.vehiclenumber = $$v
      },
      expression: "vehiclenumber"
    }
  })], 1), _vm._v(" "), (this.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vehicle No(CG07BC9186)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "name": "vehiclenumberInput",
      "id": "vehiclenumberInput"
    },
    model: {
      value: (_vm.vehiclenumberInput),
      callback: function($$v) {
        _vm.vehiclenumberInput = $$v
      },
      expression: "vehiclenumberInput"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.vehiclenumber || _vm.vehiclenumberInput) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.getAllECHALLAN01Func()
      }
    }
  }, [_vm._v("Fetch")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.toggleView
    }
  }, [_vm._v("\n          " + _vm._s(_vm.showOriginalTables ? 'Modern View' : 'Original View') + "\n        ")])], 1)], 1), _vm._v(" "), (!_vm.isLoading) ? _c('div', [(_vm.vehiclenumber || _vm.vehiclenumberInput) ? _c('div', {
    staticClass: "mb-3"
  }, [_c('b', [_vm._v("Vehicle Number:")]), _vm._v(" " + _vm._s((_vm.getAllECHALLAN01 && _vm.getAllECHALLAN01.data && _vm.getAllECHALLAN01.data.vehicleNumber) ||
    _vm.vehiclenumber) + "\n        "), (_vm.getAllECHALLAN01.message) ? _c('span', {
    staticClass: "ml-3 text-success"
  }, [_vm._v(_vm._s(_vm.getAllECHALLAN01.message))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n          Data: " + _vm._s(_vm.pendingChallans.length) + " pending, " + _vm._s(_vm.disposedChallans.length) + " disposed, \n          Total: " + _vm._s(_vm.combinedChallanData.length) + " challans\n          "), (!_vm.vehiclenumber) ? _c('span', [_vm._v(" (All Vehicles)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('VehicleChallanList', {
    attrs: {
      "show-trigger-button": false,
      "modal-title": "All Vehicle Challan Records",
      "auto-load": false,
      "inline-display": true,
      "challan-data": _vm.combinedChallanData
    }
  })], 1), _vm._v(" "), (_vm.showOriginalTables) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('h5', [_vm._v("Pending Challans")]), _vm._v(" "), (_vm.pendingChallans.length > 0) ? _c('b-table', {
    attrs: {
      "items": _vm.pendingChallans,
      "fields": _vm.challanFields,
      "small": "",
      "bordered": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "challan_status",
      fn: function(row0) {
        return [_c('b-badge', {
          attrs: {
            "variant": row0.item.challan_status === 'Pending' ? 'warning' : 'secondary'
          }
        }, [_vm._v(_vm._s(row0.item.challan_status))])]
      }
    }, {
      key: "offence_details",
      fn: function(row0) {
        return [_c('ul', {
          staticClass: "mb-0 pl-3"
        }, _vm._l((row0.item.offence_details), function(off, idx) {
          return _c('li', {
            key: idx
          }, [_vm._v(_vm._s(off.act) + " " + _vm._s(off.name))])
        }))]
      }
    }])
  }) : _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("No Pending Challans")])], 1) : _vm._e(), _vm._v(" "), (_vm.showOriginalTables) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('h5', [_vm._v("Disposed Challans")]), _vm._v(" "), (_vm.disposedChallans.length > 0) ? _c('b-table', {
    attrs: {
      "items": _vm.disposedChallans,
      "fields": _vm.challanFields,
      "small": "",
      "bordered": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "challan_status",
      fn: function(row0) {
        return [_c('b-badge', {
          attrs: {
            "variant": row0.item.challan_status === 'Disposed' ? 'success' : 'secondary'
          }
        }, [_vm._v(_vm._s(row0.item.challan_status))])]
      }
    }, {
      key: "offence_details",
      fn: function(row0) {
        return [_c('ul', {
          staticClass: "mb-0 pl-3"
        }, _vm._l((row0.item.offence_details), function(off, idx) {
          return _c('li', {
            key: idx
          }, [_vm._v(_vm._s(off.act) + " " + _vm._s(off.name))])
        }))]
      }
    }])
  }) : _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("No Disposed Challans")])], 1) : _vm._e()]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b0baed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/ECHALLAN_ResponseDisplay.vue
// module id = 2583
// module chunks = 0